var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"princ",attrs:{"src":"/img/autonomia.png"}}),_vm._v(" "),_c('img',{attrs:{"src":_vm.$t('pages.welcome.ripph_img')}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d3a459a","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Logo.vue
// module id = 3ID+
// module chunks = 70